import React from 'react';
import styled from 'styled-components';

// components
import CancelledSubscriptions from 'pages/MerchantPages/Analytics/components/CancelledSubscriptions';
import ActiveSubscriptions from 'pages/MerchantPages/Analytics/components/ActiveSubscriptions';
import ActiveSubscribersChart from 'pages/MerchantPages/Analytics/components/ActiveSubscribersChart';
import { Typography } from '@inplayer-org/inplayer-ui';
import SubscriptionsMap from './SubscriptionsMap';
import Tile from '../components/Tile';

interface SubscriptionsContainerProps {
  gridTemplateColumns?: string;
  marginTop?: string;
}
export const SubscriptionsContainer = styled.div<SubscriptionsContainerProps>`
  display: grid;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns ?? '1fr 1fr'};
  grid-gap: 1.6rem;
  margin-top: ${({ marginTop }) => marginTop};
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const SubscribersSection: React.FC = () => {
  return (
    <>
      <SubscriptionsContainer>
        <ActiveSubscribersChart />
        <FlexContainer>
          <Tile
            title=""
            tileWidth="100%"
            tileMargin="0 0 1rem 0"
            tileContent={
              <Typography variant="h6">
                These analytics are not available at the moment. For inquiries regarding subscription analytics, please
                contact support@inplayer.com
              </Typography>
            }
          />
          {/* temporarily comment active and canceled subs due to BE issue */}
          {/* <ActiveSubscriptions />
          <CancelledSubscriptions /> */}
        </FlexContainer>
      </SubscriptionsContainer>
      {/* temporarily remove subscriptions map */}
      {/* <SubscriptionsContainer marginTop="1rem" gridTemplateColumns="1fr">
        <SubscriptionsMap />
      </SubscriptionsContainer> */}
    </>
  );
};

export default SubscribersSection;
